export default "__VITE_ASSET__D4N2fg4A__"